import { useMemo } from "react";
import { TAB_KEYS, TabKey } from "../types";

interface Tab {
  labelKey: string;
  value: TabKey;
  isActive: boolean;
}

/**
 * Custom hook for managing tab configuration
 * Provides tab data and active state logic
 */
export function useTabConfiguration(activeTab: TabKey) {
  const tabs: Tab[] = useMemo(
    () => [
      {
        labelKey: "aboutUsPage.leadership.navigation.boardOfDirectors",
        value: TAB_KEYS.BOARD_OF_DIRECTORS,
        isActive: activeTab === TAB_KEYS.BOARD_OF_DIRECTORS,
      },
      {
        labelKey: "aboutUsPage.leadership.navigation.leadershipWord",
        value: TAB_KEYS.LEADERSHIP_WORD,
        isActive: activeTab === TAB_KEYS.LEADERSHIP_WORD,
      },
      {
        labelKey: "aboutUsPage.leadership.navigation.socialResponsibility",
        value: TAB_KEYS.SOCIAL_RESPONSIBILITY,
        isActive: activeTab === TAB_KEYS.SOCIAL_RESPONSIBILITY,
      },
      {
        labelKey: "aboutUsPage.leadership.navigation.subsidiaries",
        value: TAB_KEYS.SUBSIDIARIES,
        isActive: activeTab === TAB_KEYS.SUBSIDIARIES,
      },
    ],
    [activeTab],
  );

  return {
    tabs,
  };
}
